import { getDefinitionByName } from '@legacy-modules/common/util/kpiDefinitions';

import { ChartType } from '@legacy-modules/metrics2/models/enumerations/ChartType';
import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';
import ValueExpression, {
  TargetValueType,
} from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

export default new ValueExpression({
  identifier: 'regression-gutschriften/abwicklungsmenge',
  label: 'S&V-Quote (ZSB/VP+)',
  valueFormat: '-#.###.##0,##0%',
  chart: ChartType.bar,
  positiveDirection: PositiveDirection.down,
  category: 'tours',
  definition: getDefinitionByName('S&V-Quote (ZSB/VP+)'),
  // LMAJSM-489: released for ZSB/VP+ — data is built by lma-scheduler boimport into
  // lm_schaden_verlust_aggregations. NOTE: requires PO sign-off before shipping to prod.
  hidden: false,
  valueQuotient: 0.01,
  percent: true,
  targetValueType: TargetValueType.QUOTE,
  decimalPlaces: 3,
});
